import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Field, Modal, TextInput } from './ui';

export function ConfirmDialog({
  title,
  body,
  phrase,
  confirmLabel,
  danger,
  busy,
  children,
  onConfirm,
  onClose,
}: {
  title: string;
  body: string;
  /** When set, the confirm button stays disabled until this text is typed. */
  phrase?: string;
  confirmLabel: string;
  danger?: boolean;
  busy?: boolean;
  children?: ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [typed, setTyped] = useState('');
  const ready = !phrase || typed.trim() === phrase;
  return (
    <Modal title={title} onClose={onClose}>
      <p className="text-sm text-fg-muted">{body}</p>
      {children}
      {phrase ? (
        <div className="mt-4">
          <Field label={t('typePhrase', { phrase })}>
            <TextInput
              value={typed}
              autoComplete="off"
              onChange={(event) => setTyped(event.target.value)}
            />
          </Field>
        </div>
      ) : null}
      <div className="mt-5 flex justify-end gap-2">
        <Button variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          variant={danger ? 'danger' : 'primary'}
          disabled={!ready}
          loading={busy}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
